<template>
  <div>
    <side-nav />
    <div class="app-container" v-bind:class="{ __sidebar: isSidebarActive, __navbar: isTopNavbarActive }">
      <top-nav />
      <div class="row" v-if="errorMessage">
        <div class="col-xs-12">
          <alert messageType="error">
            <span slot="message">{{errorMessage}}</span>
          </alert>
        </div>
      </div>
      <router-view />
    </div>
    <div v-if="showModalBackdrop" class="modal-backdrop fade in"></div>
    <authorize />
  </div>
</template>

<script>
import Alert from '@/components/Alert'
import Authorize from './auth/Authorize'
import TopNav from '@/components/secure/nav/TopNav'
import SideNav from '@/components/secure/nav/SideNav'
import NavMixin from './nav/NavMixin'
import * as types from '@/vuex/mutation-types'
import ErrorLoggingService from '@/services/ErrorLoggingService'
import { mapGetters } from 'vuex'
import Visibility from 'visibilityjs'

export default {
  name: 'secureApp',
  components: {
    TopNav,
    SideNav,
    Authorize,
    Alert
  },
  data () {
    return {
      errorMessage: '',
      errorMessages: {
        loadProfileError: 'There was a problem loading some data. Please try refreshing the page.'
      }
    }
  },
  computed: {
    ...mapGetters([
      'authContextLoaded'
    ]),
    showModalBackdrop: function () {
      return this.$store.state.globalStore.showModalBackdrop
    }
  },
  mixins: [NavMixin],
  created () {
    this.loadAppData()
    const self = this
    Visibility.change(function (e, state) {
      if (state === 'visible') {
        self.loadAppData()
      }
    })
  },
  methods: {
    loadAppData: async function () {
      this.errorMessage = ''
      try {
        await this.$store.dispatch(types.UP_LOAD_PROFILE)
      } catch (err) {
        ErrorLoggingService.logError(err)
        this.errorMessage = this.errorMessages.loadProfileError
      }
    }
  }
}
</script>
